import { render, staticRenderFns } from "./InvoiceList-Refund.vue?vue&type=template&id=6b617530&scoped=true"
import script from "./InvoiceList-Refund.vue?vue&type=script&lang=js"
export * from "./InvoiceList-Refund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b617530",
  null
  
)

export default component.exports